/** @format */

/**
 * Circle membership is stored on both sides: `circle.members[].memberId` (the
 * source of truth the server uses for contributions and the dashboard's
 * "my circles" list) and `user.unions` (a convenience copy on the user). If a
 * join was only half-written in the past, the two can disagree, so check both.
 * Entries may be ObjectId strings or populated objects.
 */

const toId = (value: any): string | null => {
	if (!value) return null;
	if (typeof value === "string") return value;
	if (typeof value === "object" && value._id) return String(value._id);
	return String(value);
};

export const userUnionsInclude = (
	unions: any[] | null | undefined,
	circleId: string | null | undefined,
): boolean =>
	!!circleId && (unions ?? []).some((union) => toId(union) === String(circleId));

export const circleMembersInclude = (
	members: any[] | null | undefined,
	userId: string | null | undefined,
): boolean =>
	!!userId &&
	(members ?? []).some(
		(member) => toId(member?.memberId ?? member) === String(userId),
	);

export const circleListIncludes = (
	circles: any[] | null | undefined,
	circleId: string | null | undefined,
): boolean =>
	!!circleId && (circles ?? []).some((circle) => toId(circle) === String(circleId));
